<template>
  <div class="cmp-settings-language-language_settings dt-page">
    <v-layout v-if="!credentialExists" class="needcred-form-container login-white" row wrap>
      <LoginForm @change="onLoginUserChange" />
    </v-layout>
    <v-layout row wrap class="dt-page--top-bar" v-if="credentialExists">
      <div class="dt-page--add-button">
        <img
          @click="onAddI18nClick"
          class="dt-icon v5 s1"
          src="static/buttons/add.svg"
          :title="$t('add_in_entry')"
          :alt="$t('add_in_entry')"
        />
      </div>
      <div class="search">
        <InputField
          :value="searchString"
          :placeholder="$t('search')"
          :config="{
              borderStyle: 'around'
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
      </div>
      <Dropdown
        class="language-dropdown bb1"
        :options="language_listTV"
        v-if="language_listTV && language_listTV.length > 0"
        :selected="language_listTV.find(e => e.value == lang_code)"
        :placeholder="$t('language')"
        v-on:selectedChange="e => onLangCodeChange(e)"
        :listHeight="400"
        disabled
      ></Dropdown>
      <div class="right-space"></div>
    </v-layout>
    <v-layout column wrap v-if="credentialExists">
      <div class="language-list-table-container">
        <NTable
          :id="'settings-language-language_settings_list'"
          class="h1"
          :config="tableConfig"
          :headers="i18nListHeaders"
          :items="list"
        >
          <template v-slot:item="{ item, tdcon }">
            <tr :title="item.textkey">
              <td @click="oni18nClick(item)" v-bind="tdcon('text_key')">
                <span>{{ item['textkey'] }}</span>
              </td>
              <td v-bind="tdcon('section')">
                <span>{{ item['section'] }}</span>
              </td>
              <td v-bind="tdcon('term')">
                <input
                  v-if="lang_code"
                  type="text"
                  class="ntable--textfield"
                  :placeholder="$t('term')"
                  :value="item[lang_code]"
                  v-on:blur="e => onTextInputBlur(e.target.value, item)"
                />
              </td>
            </tr>
          </template>
        </NTable>
      </div>
    </v-layout>
    <ModalContainer v-if="language_listTV && language_listTV.length > 0" :modalKey="'addI18n'" :width="'small'" @cancelled="onHideComponentModal">
      <I18NForm
        :language_listTV="language_listTV"
        :sectionsTV="sectionsTV"
        @added="onNewI18NEntryAdded"
        @cancelled="onHideComponentModal"
      />
    </ModalContainer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import NTable from "@/plugins/datatable/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";
import Sidewindow from "@dtplugins/sidewindow/sidewindow";

import * as ActionTypes from "../../store/types";
import { SettingsStoreNamespace as storeNS } from "../../store";

import { createModalMixin, openModalRoute, closeModalRoute } from "../../../../dt-plugins/modal/modal.mixin";

import InputField from "@plugins/text-field/input-field";

import LoginForm from "../../../../dt-plugins/login/login-form";
import { createNeedCredential } from "../../../../dt-plugins/credential/need-credential";
import { createNTableConfig, createTableHeader } from "../../../../plugins/datatable";
import { mapActionObject } from "../../../../store/global";
import { languageSettingsActions } from "../../store/language/actions";

import I18NForm from './i18n-form';
import { Subject } from 'rxjs';
import { subscribeSubject } from '../../../../utility';

export default {
  components: {
    NTable,
    InputField,
    LoginForm,
    Sidewindow,
    ModalContainer,

    I18NForm
  },
  mounted: async function() {
    subscribeSubject(this, this.searchSubject, (searchString) => {
      this[ActionTypes.I18NEntry.SEARCH.MULTIPLE]({
        searchString: this.searchString
      });
    })
  },
  data: function() {
    return {
      tableConfig: createNTableConfig({
        fullHeight: true
      }),
      searchString: "",
      lang_code: "be",

      searchSubject: new Subject(),
      searchString: '',
    };
  },
  mixins: [createNeedCredential(), createModalMixin("addI18n")],
  watch: {
    // language_listTV: {
    //   immediate: true,
    //   handler: function(to, from) {
    //     if (to && to.length > 0 && !this.lang_code) {
    //       this.lang_code = to?.[0]?.value;
    //       console.log("Log: this.lang_code", this.lang_code, to[0])
    //     }
    //   }
    // }
  },
  computed: {
    ...mapGetters(storeNS, {
      languageSettingsData: "languageSettingsData"
    }),
    i18nListHeaders: function() {
      return [
        createTableHeader("text_key", { text: `${this.$t("text")} ${this.$t("key")}`, fw: 700 }),
        createTableHeader("section"),
        createTableHeader("term", { mw: 40 })
      ];
    },
    list: function() {
      return this.languageSettingsData?.i18n || [];
    },
    language_list: function() {
      return this.languageSettingsData?.language_list || [];
    },
    language_listTV: function() {
      return this.language_list.map(e => ({
        text: e.key,
        value: e.index
      }));
    },
    sections: function() {
      return this.languageSettingsData?.sections || [];
    },
    sectionsTV: function() {
      return this.sections?.map(e => ({
        text: e?.section,
        value: e?.section,
      })) || [];
    }
  },
  methods: {
    ...mapActionObject(storeNS, languageSettingsActions),
    fetchList: function() {
      this[ActionTypes.LanguageSettingsData.FETCH.ALL]({
        user_name: this.username,
        password: this.password
      });
    },
    onAddI18nClick: function() {
      openModalRoute(this, "add_i18n");
    },
    onHideComponentModal: function() {
      closeModalRoute(this);
    },
    oni18nClick: function(item) {
     
    },
    oni18nDelete: function(i18n) {
      console.log(i18n);
    },
    onNewI18NEntryAdded: function(i18n) {
      this[ActionTypes.I18NEntry.INSERT.SINGLE](i18n);
      this.onHideComponentModal();
    },
    onTextInputBlur: function(value, item) {
      const name = item.textkey;
      if (this.lang_code) {
        this[ActionTypes.I18NEntry.UPDATE.SINGLE]({ name, value, item, lang_code: this.lang_code });
      }
    },
    onSearchInputKeyup: function(event) {
      this.searchString = event.target.value;
      this.searchSubject.next(this.searchString);
    },
    onLangCodeChange: function(value) {
      // if (value && value.value) {
      //   this.lang_code = value.value;
      // }
    },

    //MARK: Method
  }
};
</script>

<style lang="scss">
.cmp-settings-language-language_settings {
  .language-list-table-container {
    height: 100%;
    // background: green;
  }

  .dt-page--top-bar {
    .language-dropdown {
      flex: 1;
    }
  }

  .dt-ntable {
    td:first-child {
      color: black;
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
      th:nth-child(2),
      td:nth-child(2) {
        display: none;
      }
      th:nth-child(3),
      td:nth-child(3) {
        display: none;
      }
    }
  }
}
</style>
